// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__0dyx0","loading_text":"loader_loading_text__+pyRc","loading_spinner":"loader_loading_spinner__QWH4c","loaderspin":"loader_loaderspin__tcyx6"};